import { useEffect } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * A component that applies some effect on the map.
 *
 */
const MapEffects = _ref => {
  let {
    item,
    results,
    effect
  } = _ref;
  switch (effect.is) {
    case "highlightAll":
      return /*#__PURE__*/_jsx(HighlightResults, {
        item: item,
        results: results
      });
    case "highlightSingleResult":
      return /*#__PURE__*/_jsx(HighlightResults, {
        item: item,
        results: effect.result
      });
    case "showMatchingOnly":
      return /*#__PURE__*/_jsx(HideAllResults, {
        item: item,
        results: results
      });
    case "none":
      return null;
  }
};
export default MapEffects;
export const HideAllResults = props => {
  const {
    item,
    results
  } = props;
  useEffect(() => {
    const disposer = item.hideFeaturesNotInItemSearchResults(results);
    return disposer;
  }, [item, results]);
  return null;
};
export const HighlightResults = props => {
  useEffect(() => {
    const item = props.item;
    const results = Array.isArray(props.results) ? props.results : [props.results];
    if (results.length === 1) zoomToResult(item, results[0]);
    const disposer = item.highlightFeaturesFromItemSearchResults(results);
    return disposer;
  }, [props.item, props.results]);
  return null;
};
function zoomToResult(item, result) {
  item.zoomToItemSearchResult(result);
}